import { useEffect, useState } from "react";

/** Returns `value` once it has stopped changing for `delayMs` (e.g. to avoid a request per keystroke). */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
